import { useTranslations } from "use-intl";

export function BookingGraphic() {
  const t = useTranslations("booking.bookingEmpty");

  const cardX = 150;
  const cardY = 40;
  const cardW = 220;
  const cardH = 90;
  const center = cardX + cardW / 2;

  return (
    <div className="rounded-xl bg-gray-50 p-4">
      <svg
        viewBox="0 0 520 150"
        className="w-full"
        role="img"
        aria-label={t("subtitle")}
      >
        <rect
          x={cardX - 70}
          y={cardY + 14}
          width={120}
          height={cardH - 28}
          rx={10}
          fill="#e2e8f0"
        />
        <rect
          x={cardX + cardW - 50}
          y={cardY + 14}
          width={120}
          height={cardH - 28}
          rx={10}
          fill="#e2e8f0"
        />

        <rect
          x={cardX}
          y={cardY}
          width={cardW}
          height={cardH}
          rx={12}
          fill="#ffffff"
          stroke="#10b981"
          strokeWidth={2}
        />

        <g>
          <rect
            x={cardX + 20}
            y={cardY + 36}
            width={60}
            height={16}
            rx={6}
            fill="#059669"
          />
          <path
            d={`M ${cardX + 34} ${cardY + 36} q 4 -10 16 -10 h 6 q 8 0 12 10 z`}
            fill="#10b981"
          />
          <circle cx={cardX + 34} cy={cardY + 54} r={4.5} fill="#065f46" />
          <circle cx={cardX + 66} cy={cardY + 54} r={4.5} fill="#065f46" />
        </g>

        <rect
          x={cardX + 100}
          y={cardY + 26}
          width={96}
          height={6}
          rx={3}
          fill="#94a3b8"
        />
        <rect
          x={cardX + 100}
          y={cardY + 42}
          width={72}
          height={6}
          rx={3}
          fill="#cbd5e1"
        />
        <rect
          x={cardX + 100}
          y={cardY + 58}
          width={84}
          height={6}
          rx={3}
          fill="#cbd5e1"
        />

        <g>
          <rect
            x={center - 52}
            y={14}
            width={104}
            height={26}
            rx={13}
            fill="#10b981"
          />
          <text
            x={center}
            y={31}
            textAnchor="middle"
            fontSize={13}
            fontWeight={600}
            fill="#ffffff"
          >
            {t("graphicLabel")}
          </text>
        </g>
      </svg>
    </div>
  );
}
